import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Group, User } from '@era/security-sdk';
import { GroupStoreSelectors, MemberGroupStoreActions, MemberUserStoreActions, UserStoreSelectors } from '@era/stores';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { filter, take } from 'rxjs/operators';
import { AddMemberModalComponent } from '../add-member-modal/add-member-modal.component';
import { MemberListComponent } from './member-list.component';

@Component({
  selector: 'era-security-member-list',
  templateUrl: './member-list.container.html',
  styleUrls: ['./member-list.container.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MemberListComponent],
})
export class MemberListContainerComponent {
  private readonly store = inject(Store);
  private readonly modalService = inject(NgbModal);

  public readonly group = this.store.selectSignal(GroupStoreSelectors.selectCurrentGroup);
  public editEnabled = false;

  toggleEditEvent(): void {
    this.editEnabled = !this.editEnabled;
  }

  addUserEvent() {
    const modelRef = this.modalService.open(AddMemberModalComponent);
    this.store
      .select(UserStoreSelectors.selectAllPossibleUsers)
      .pipe(
        filter((x: User[]) => x.length > 0),
        take(1)
      )
      .subscribe((x) => {
        if (modelRef.componentInstance) {
          modelRef.componentInstance.items = x;
        }
      });

    modelRef.result.then(
      (result: User) => {
        const currentGroup = this.group();
        if (!currentGroup) {
          return;
        }

        this.store.dispatch(
          MemberUserStoreActions.GroupApiActions.memberUsersAdded({ group: currentGroup, userToAdd: result })
        );
      },

      () => {
        return;
      }
    );
  }

  addGroupEvent() {
    const modelRef = this.modalService.open(AddMemberModalComponent);
    this.store
      .select(GroupStoreSelectors.selectAllPossibleChildren)
      .pipe(take(1))
      .subscribe((x) => {
        if (modelRef.componentInstance) {
          modelRef.componentInstance.items = x;
        }
      });

    modelRef.result.then(
      (result: Group) => {
        const currentGroup = this.group();
        if (!currentGroup) {
          return;
        }

        this.store.dispatch(
          MemberGroupStoreActions.MemberGroupApiActions.memberGroupsAdded({ group: currentGroup, groupToAdd: result })
        );
      },
      () => {
        return;
      }
    );
  }
}
